const block_icons     = {
    section_icon:   <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
  >
    <g xmlns="http://www.w3.org/2000/svg" fill="#e71515">
      <path
        d="M501.333 170.667H10.667A10.66 10.66 0 000 181.333v21.333a10.66 10.66 0 0010.667 10.667h490.667a10.66 10.66 0 0010.667-10.667v-21.333a10.662 10.662 0 00-10.668-10.666zM309.333 298.667H10.667A10.66 10.66 0 000 309.333v21.333a10.66 10.66 0 0010.667 10.667h298.667a10.66 10.66 0 0010.667-10.667v-21.333a10.662 10.662 0 00-10.668-10.666zM309.333 426.667H10.667A10.66 10.66 0 000 437.333v21.333a10.66 10.66 0 0010.667 10.667h298.667a10.66 10.66 0 0010.667-10.667v-21.333a10.662 10.662 0 00-10.668-10.666zM501.333 42.667H74.667A10.66 10.66 0 0064 53.333v21.333a10.66 10.66 0 0010.667 10.667h426.667a10.66 10.66 0 0010.667-10.667V53.333a10.662 10.662 0 00-10.668-10.666zM501.333 277.333H416c-29.406 0-53.333 23.927-53.333 53.333S386.594 384 416 384h10.667v74.667a10.66 10.66 0 0010.667 10.667 10.66 10.66 0 0010.667-10.667v-160h21.333v160a10.66 10.66 0 0010.667 10.667 10.66 10.66 0 0010.667-10.667v-160h10.667c5.896 0 10.667-4.771 10.667-10.667s-4.773-10.667-10.669-10.667z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}

export default block_icons;